import { render, staticRenderFns } from "./LikewizeConfirmHome.vue?vue&type=template&id=215fcea8&scoped=true"
import script from "./LikewizeConfirmHome.vue?vue&type=script&lang=js"
export * from "./LikewizeConfirmHome.vue?vue&type=script&lang=js"
import style0 from "./LikewizeConfirmHome.vue?vue&type=style&index=0&id=215fcea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215fcea8",
  null
  
)

export default component.exports